import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({ input, label, meta: { touched, error } }) => {
  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <ReactQuill
        theme="snow"
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        modules={{
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
          ]
        }}
        formats={['bold', 'italic', 'underline', 'list', 'bullet', 'link']}
      />
      {touched && error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  );
};

export default RichTextEditor;
